export default defineNuxtPlugin(() => {
  String.prototype.format = function () {
    return [...arguments].reduce((p, c) => p.replace(/%s/, encodeURIComponent(c)), this)
  }

  String.prototype.queryString = function () {
    return [...arguments].reduce(
      (p, c) =>
        (!!c ? (p.includes('?') ? `${p}&${c}` : `${p}?${c}`) : p)
          .replace('&&', '&')
          .replace('&?', '&')
          .replace('??', '?')
          .replace('?&', '?'),
      this
    )
  }
})
